import React from 'react';
import ZohoSetup from '../../components/zoho-crm/ZohoSetup';

const ZohoIntegration = () => {
  return <ZohoSetup />;
};

export default ZohoIntegration;